import React,{ useState, useEffect } from 'react';
import { projectStorage } from '../firebase/config';

const useDelete = (deteleUrl, setPictresURL, picturesURL) => {
  const [error, setError] = useState('');

  useEffect(() => {
    // references
    // Create a storage reference from our storage service
    if (deteleUrl) {
      const pictureRef = projectStorage.refFromURL(deteleUrl);

      pictureRef
        .delete()
        .then(() => {
          setPictresURL(picturesURL.filter(image => image !== deteleUrl));
          alert('Picture is deleted successfully');
          setError('Picture is deleted successfully');
        })
        .catch(err => {
          console.log(err);
        });
    }
  }, [deteleUrl]);

  return { error };
};

export default useDelete;
